module.exports = __webpack_public_path__ + "03_veryshort_gold.5be33e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_veryshort_gold.png
// module id = 5J3Z
// module chunks = 0